/**
 *  toast 组件，用于显示通知消息。
 */
import { createApp } from 'vue'
import FeedbackToast from '../components/feedback/FeedbackToast.vue'

interface ToastOptions {
  message: string
  type?: 'success' | 'error' | 'warning' | 'info'
  duration?: number
  position?: 'top-right' | 'top-center' | 'top-left' | 'center' | 'bottom-right' | 'bottom-center' | 'bottom-left'
}

class ToastManager {
  private container: HTMLElement | null = null

  constructor() {
    // 创建一个容器用于存放所有toast
    this.container = document.createElement('div')
    this.container.className = 'toast-container'
    document.body.appendChild(this.container)
  }

  show(options: ToastOptions) {
    const { message, type = 'info', duration = 3000, position = 'top-right' } = options

    // 创建toast组件实例并设置props
    const div = document.createElement('div')
    div.classList.add('toast')
    this.container!.appendChild(div)

    // 创建Vue应用并挂载组件
    const app = createApp(FeedbackToast, {
      message,
      type,
      duration,
      visible: true,
      position,
      'onUpdate:visible': (visible: boolean) => {
        if (!visible) {
          // 当toast关闭时，卸载应用
          app.unmount()
          div.remove()
        }
      }
    })
    app.mount(div)
  }

  success(message: string, duration?: number, position?: ToastOptions['position']) {
    this.show({ message, type: 'success', duration, position })
  }

  error(message: string, duration?: number, position?: ToastOptions['position']) {
    this.show({ message, type: 'error', duration, position })
  }

  warning(message: string, duration?: number, position?: ToastOptions['position']) {
    this.show({ message, type: 'warning', duration, position })
  }

  info(message: string, duration?: number, position?: ToastOptions['position']) {
    this.show({ message, type: 'info', duration, position })
  }

  showToast(type: 'success' | 'error' | 'warning' | 'info', message: string, duration?: number, position?: ToastOptions['position']) {
    this.show({ message, type, duration, position })
  }
}

// 创建单例实例
const toastManager = new ToastManager()

export const useToast = () => toastManager
